module.exports = __webpack_public_path__ + "static/img/image11.e6dce16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image11.png
// module id = G6aM
// module chunks = 14